"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.insuranceFragments = exports.insuranceTransferFragment = exports.insuranceFragment = void 0;
exports.insuranceFragment = `
  fragment insurance on Insurance {
    id
    company
    organisationNumber
    policyId
    insuranceType
    mileagePerYear
    transfer {
      ...insuranceTransfer
    }
  }
`;
exports.insuranceTransferFragment = `
  fragment insuranceTransfer on InsuranceTransfer {
    id
    company
    registrationNumber
    organisationNumber
  }
`;
exports.insuranceFragments = `
  ${exports.insuranceFragment}
  ${exports.insuranceTransferFragment}
`;
//# sourceMappingURL=insurance.js.map